import {
    CompleteDelegateeList,
    CompleteUpdateUserSettings,
    CompleteUserSettings,
    ReceiveDelegateeList,
    ReceiveUpdateUserSettings,
    ReceiveUserSettings,
    RequestDelegateeList,
    RequestUpdateUserSettings,
    RequestUserSettings,
    UpdateUserSettings,
} from "../actions/userSettingsActions";
import { AppThunkAction } from "../store";
import { actionTypes as userSettingsActions } from "../types/userSettingsTypes";
import { actionTypes as notifactionAction } from "../types/notificationTypes";
import { NotificationAction, StatusType } from "../store/Common/NotificationStore";
import axios, { AxiosResponse } from "axios";
import { IDelegateeUser, IUserSettingsModel } from "../Core/ViewModels/User/UserViewModel";
import { AppNotifier } from "src/components/Common/Notification/AppNotifier";
import { ToasterMessages } from "src/helper/ToasterMessages";

export type DispatchActions =
    | RequestUserSettings
    | ReceiveUserSettings
    | CompleteUserSettings
    | RequestDelegateeList
    | ReceiveDelegateeList
    | CompleteDelegateeList
    | RequestUpdateUserSettings
    | ReceiveUpdateUserSettings
    | CompleteUpdateUserSettings
    | UpdateUserSettings;

export type KnownActions = DispatchActions | NotificationAction;

export const fetchUsersList = (): AppThunkAction<KnownActions> => (dispatch, getState) => {
    dispatch({
        type: userSettingsActions.REQUEST_DELEGATEE_LIST,
    });
    axios
        .get(`${process.env.REACT_APP_API_URL}/api/Contact/GetSupportContactList`)
        .then((response: AxiosResponse<IDelegateeUser[]>) => {
            const { data } = response;
            dispatch({
                type: userSettingsActions.RECEIVE_DELEGATEE_LIST,
                payload: data.filter(user => user.userId != getState().userProfile.userId),
            });
        })
        .catch(function (error: Error) {
            dispatch({
                type: notifactionAction.NOTIFICATION,
                statusMessage: error.message,
                statusType: StatusType.Error,
            });
            dispatch({
                type: userSettingsActions.COMPLETE_DELEGATEE_LIST,
            });
        });
};

export const fetchUserSettings =
    (callback?: (data: IUserSettingsModel) => void): AppThunkAction<KnownActions> =>
    dispatch => {
        dispatch({ type: userSettingsActions.REQUEST_USER_SETTINGS });
        axios
            .get(`${process.env.REACT_APP_API_URL}/api/User/GetUserSettingsModel`)
            .then((response: AxiosResponse<IUserSettingsModel>) => {
                const { data } = response;
                dispatch({
                    type: userSettingsActions.RECEIVE_USER_SETTINGS,
                    payload: data,
                });
                if (callback) {
                    callback(data);
                }
            })
            .catch(function (error: Error) {
                dispatch({
                    type: notifactionAction.NOTIFICATION,
                    statusMessage: error.message,
                    statusType: StatusType.Error,
                });
                dispatch({
                    type: userSettingsActions.COMPLETE_USER_SETTINGS,
                });
            });
    };

export const updateUserSettings =
    (payload: IUserSettingsModel, callback?: () => void): AppThunkAction<KnownActions> =>
    dispatch => {
        dispatch({ type: userSettingsActions.REQUEST_UPDATE_USER_SETTINGS });
        axios
            .put(`${process.env.REACT_APP_API_URL}/api/User/UpdateExchangeUserSettings`, payload)
            .then(() => {
                dispatch({
                    type: userSettingsActions.RECEIVE_UPDATE_USER_SETTINGS,
                });

                dispatch({
                    type: userSettingsActions.UPDATE_USER_SETTINGS,
                    payload: payload,
                });

                AppNotifier.Success(ToasterMessages.SUCCESS.APPLY_USER_SETTINGS);
                if (callback) {
                    callback();
                }
            })
            .catch(function (error: Error) {
                dispatch({
                    type: notifactionAction.NOTIFICATION,
                    statusMessage: error.message,
                    statusType: StatusType.Error,
                });
                dispatch({
                    type: userSettingsActions.COMPLETE_UPDATE_USER_SETTINGS,
                });
            });
    };
